import { gql } from '@apollo/client';

export const SET_BRAND_DEAL_SETTINGS = gql`
  mutation SetBrandDealSettings($input: SetBrandDealSettingsInput!) {
    setBrandDealSettings(input: $input) {
      id
      contactEmail
      contactPhone
      minFlatPrice
      minBookMePrice
      minSocialPrice
      minSocialSharePrice
      minSponsoredLivePrice
      industryCategories {
        isEnabled
        label
        value
      }
      isAcceptingFreeProducts
      isArticlesPrEnabled
    }
  }
`;

export const TRACK_EXT_TALENT_CTA_CLICK = gql`
  mutation TrackExtTalentCtaClick($input: TrackExtTalentCtaClickInput!) {
    trackExtTalentCtaClick(input: $input)
  }
`;

export const INVITE_EXT_TALENT_TO_DEAL = gql`
  mutation InviteExtTalentToDeal {
    inviteExtTalentToDeal {
      offerId
      campaignId
    }
  }
`;
